var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import { colors, getStatusColor } from "@wrstudios/theme";
import BaseCard from "../../card";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: opacity 0.2s;\n  position: relative;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  a {\n    text-decoration: none;\n  }\n"], ["\n  transition: opacity 0.2s;\n  position: relative;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  a {\n    text-decoration: none;\n  }\n"])));
export var CardHeader = styled(BaseCard.Header)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
export var Badge = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: 1.2rem;\n  font-weight: 600;\n  line-height: 1.8rem;\n  padding: 0.1rem 0.5rem;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 0.3rem;\n  box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.1);\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 1;\n"], ["\n  display: inline-block;\n  font-size: 1.2rem;\n  font-weight: 600;\n  line-height: 1.8rem;\n  padding: 0.1rem 0.5rem;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 0.3rem;\n  box-shadow: 0 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.1);\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  z-index: 1;\n"])), function (_a) {
  var status = _a.status;
  return getStatusColor(status || "");
}, colors.white);
var templateObject_1, templateObject_2, templateObject_3;